import {
  ANY_LETTER_REGEX,
  ARMENIAN_BIOMETRIC_PASSPORT_REGEX,
  ARMENIAN_NON_BIOMETRIC_PASSPORT_REGEX,
  ONLY_DIGITS_REGEX,
  ONLY_LETTERS_AND_NUMBERS_REGEX,
} from '../constants/patterns';
import { isArmenianCountry } from './countryHelper';

const getArmenianPassportsValidation = (inputValue, schema) => {
  if (!ONLY_LETTERS_AND_NUMBERS_REGEX.test(inputValue)) {
    // Validation for only letters and numbers
    return schema.test(
      'armenianPassportCharacters',
      'validationErrors.armenianPassportCharacters',
      (value = '') => ONLY_LETTERS_AND_NUMBERS_REGEX.test(value),
    );
  }
  if (ANY_LETTER_REGEX.test(inputValue)) {
    // Validation for non֊biometric armenian passports
    return schema.test(
      'nonBiometricPassport',
      'validationErrors.wrongNonBiometricPassportType',
      (value = '') => ARMENIAN_NON_BIOMETRIC_PASSPORT_REGEX.test(value),
    );
  }
  if (ONLY_DIGITS_REGEX.test(inputValue)) {
    // Validation for biometric armenian passports
    return schema.test(
      'biometricPassport',
      'validationErrors.wrongBiometricPassportType',
      (value = '') => ARMENIAN_BIOMETRIC_PASSPORT_REGEX.test(value),
    );
  }

  return schema;
};

export default getArmenianPassportsValidation;

export function getPassportsValidation(citizenship, schema, test) {
  if (!test.value) {
    return schema.required('validationErrors.isRequired');
  }
  if (isArmenianCountry(citizenship)) {
    return getArmenianPassportsValidation(test.value, schema);
  }
  return schema.min(3, 'validationErrors.wrongPassportNumber');
}
